/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __assign } from "tslib";
import { createRenderable } from '../renderable';
import { createGraphicsRenderItem } from '../webgl/render-item';
import { GlobalUniformSchema, BaseSchema, AttributeSpec, UniformSpec, InternalSchema, SizeSchema, TextureSpec, ElementsSpec, ValueSpec, GlobalTextureSchema } from './schema';
import { TextShaderCode } from '../shader-code';
import { ValueCell } from '../../mol-util';
export var TextSchema = __assign(__assign(__assign({}, BaseSchema), SizeSchema), { aGroup: AttributeSpec('float32', 1, 0), aPosition: AttributeSpec('float32', 3, 0), aMapping: AttributeSpec('float32', 2, 0), aDepth: AttributeSpec('float32', 1, 0), elements: ElementsSpec('uint32'), aTexCoord: AttributeSpec('float32', 2, 0), tFont: TextureSpec('image-uint8', 'alpha', 'ubyte', 'linear'), padding: ValueSpec('number'), uBorderWidth: UniformSpec('f'), uBorderColor: UniformSpec('v3'), uOffsetX: UniformSpec('f'), uOffsetY: UniformSpec('f'), uOffsetZ: UniformSpec('f'), uBackgroundColor: UniformSpec('v3'), uBackgroundOpacity: UniformSpec('f') });
export function TextRenderable(ctx, id, values, state, materialId) {
    var schema = __assign(__assign(__assign(__assign({}, GlobalUniformSchema), GlobalTextureSchema), InternalSchema), TextSchema);
    var internalValues = {
        uObjectId: ValueCell.create(id),
    };
    var shaderCode = TextShaderCode;
    var renderItem = createGraphicsRenderItem(ctx, 'triangles', shaderCode, schema, __assign(__assign({}, values), internalValues), materialId);
    return createRenderable(renderItem, values, state);
}
//# sourceMappingURL=text.js.map